// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__IodqD","content":"GlobalSearch_content__1L76r"};